<template>
  <div class="page">
    <div class="searchBox">
      <el-form>
        <el-row>
          <el-col :span="4">
            <el-form-item>
              <el-input
                style="width:130px;margin-right: 10px;"
                placeholder="请输入关键字"
                v-model="search.keyword"
                clearable
                @keyup.enter.native="changeSearch"
                size="small"
              ></el-input>
              <el-button @click="changeSearch" type="warning" size="small">搜索</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="订单状态" :label-width="'60px'">
              <el-select
                style="width:100px;"
                class="select"
                v-model="search.state"
                @change="changeSearch"
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="item in [{label:'已取消',value:-2},{label:'全部',value:-1},{label:'已删除',value:0},{label:'已申请',value:1},{label:'已审核',value:2},{label:'退换中',value:3},{label:'物流中',value:4},{label:'退换成功',value:8}]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="支付方式" :label-width="'70px'">
              <el-select
                style="width:100px;"
                class="select"
                v-model="search.pay_type"
                @change="changeSearch"
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="item in [{label:'全部',value:-1},{label:'现金',value:0},{label:'pos机',value:5},{label:'余额',value:7},{label:'电商平台',value:11},{label:'优惠',value:12},{label:'京东聚合',value:13},{label:'拉卡拉',value:17},]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="退换方式" :label-width="'80px'">
              <el-select
                style="width:100px;"
                class="select"
                v-model="search.return_type"
                @change="changeSearch"
                size="small"
              >
                <el-option
                  v-for="item in [{label:'全部',value:-1},{label:'退款',value:1},{label:'换货',value:2},{label:'充值退款',value:3},{label:'余额退款',value:5},{label:'押金退款',value:4},{label:'订金退款',value:6}]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="退换日期" :label-width="'90px'">
              <el-date-picker
                size="small"
                @change="changeSearch"
                v-model="datetimerange"
                type="daterange"
                style="width:220px;"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="2" :offset="1">
						<resetBtn @reset="reset"></resetBtn>
          </el-col>-->
          <el-col :span="4">
            <resetBtn @reset="reset" style="width:56px;display: inline-block;margin:0px 10px;"></resetBtn>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="pageConBox">
      <el-table class="table" :data="tableData" style="width: 100%">
        <el-table-column prop="no" label="退单编号" width="140"></el-table-column>
        <el-table-column prop="order_id" label="订单编号" width="140"></el-table-column>
        <el-table-column prop="name" label="顾客">
          <template slot-scope="scope">
            <div
              @click="$router.push({path:'/huiyuan/huiyuanSee',query:{id:scope.row.user_info.user_id}})"
              style="cursor: pointer;color: #409EFF;"
            >{{scope.row.user_info.nick_name}}({{scope.row.user_info.user_mobile}})</div>
          </template>
        </el-table-column>
        <el-table-column label="退换状态" width="70">
          <template slot-scope="scope">{{$public.formatOrderReturnState(scope.row.state)}}</template>
        </el-table-column>
        <el-table-column label="结算方式" width="130">
          <template slot-scope="scope" v-if="scope.row.pay_info">
            <div v-for="(item,index) in scope.row.pay_info.pay_list" :key="index">
              <span style="padding-right: 2px;">
                {{item.pay_type==-1?'全部':''}}
                {{item.pay_type==0?'现金':''}}
                {{item.pay_type==3?'线下支付宝':''}}
                {{item.pay_type==4?'线下微信':''}}
                {{item.pay_type==5?'pos机':''}}
                {{item.pay_type==6?'找零':''}}
                {{item.pay_type==7?'余额':''}}
                {{item.pay_type==8?'赠额':''}}
                {{item.pay_type==9?'积分':''}}
                {{item.pay_type==11?'电商平台':''}}
                {{item.pay_type==12?'优惠':''}}
                {{item.pay_type==13?'京东聚合':''}}
                {{item.pay_type==17?'拉卡拉':''}}
              </span>
              {{Math.abs((item.money).toFixed(2))}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="退换方式" width="70">
          <template slot-scope="scope">
            {{scope.row.return_type==1?'退货':''}}
            {{scope.row.return_type==2?'换货':''}}
            {{scope.row.return_type==3?'充值退款':''}}
            {{scope.row.return_type==4?'押金退款':''}}
            {{scope.row.return_type==5?'余额退款':''}}
            {{scope.row.return_type==6?'订金退款':''}}
          </template>
        </el-table-column>
        <el-table-column label="订单类型" width="70">
          <template slot-scope="scope" v-if="scope.row.return_type!=3">
            {{scope.row.order_type_id==1?'商品':''}}
            {{scope.row.order_type_id==2?'洗美':''}}
            {{scope.row.order_type_id==3?'病例':''}}
            {{scope.row.order_type_id==4?'疫苗驱虫':''}}
            {{scope.row.order_type_id==5?'医疗服务':''}}
            {{scope.row.order_type_id==6?'寄养':''}}
            {{scope.row.order_type_id==7?'挂号':''}}
            {{scope.row.order_type_id==8?'活体':''}}
            {{scope.row.order_type_id==9?'虚拟类':''}}
            {{scope.row.order_type_id==10?'订金':''}}
          </template>
        </el-table-column>
        <el-table-column label="是否入库" width="70">
          <template slot-scope="scope">
            {{scope.row.is_into?'是':''}}
            {{!scope.row.is_into?'否':''}}
          </template>
        </el-table-column>
        <el-table-column label="总金额" width="80">
          <template slot-scope="scope">{{(scope.row.total_price).toFixed(2)}}</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" width="90">
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              :content="scope.row.remark"
            >
              <div
                slot="reference"
                style="width:80px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;cursor: pointer;"
              >{{scope.row.remark}}</div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="退换日期" width="140">
          <template slot-scope="scope">{{$public.FTime(scope.row.create_time)}}</template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              @click="$router.push({path:'/returnOrder/returnOrderSee',query:{id:scope.row.no,No:scope.row.order_id}})"
              type="text"
              size="small"
            >查看</el-button>
            <el-button
              v-if="scope.row.state==3"
              type="text"
              size="small"
              @click="getInvoice(scope.row)"
            >打印小票</el-button>
            <!-- <el-button
            v-if="scope.row.state==1&&$buttonAuthority('dingdan-returnOrder-settle')"
              @click="edit(scope.row)"
              type="text"
              size="small"
            >结算</el-button> -->
            <el-button
              v-if="scope.row.state==1&&$buttonAuthority('dingdan-returnOrder-cancel')"
              @click="handelCancelClick(scope.row)"
              type="text"
              size="small"
            >取消</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row>
        <el-col>
          <div style="padding:20px;font-size:14px;">本页合计：{{totalMoney}}</div>
        </el-col>
      </el-row>
      <page
        :total="page.total"
        :page="page.page"
        @change="changePage"
        style="padding-bottom: 10px;"
      ></page>
    </div>
    <!-- 结算弹窗 -->
    <div>
      <!-- :type="curOrder.return_type==1?'returnGoods':'exchangeGoods'" -->
      <dialogSettlement
        v-if="dialogSettlementState"
        :type="'returnGoods'"
        :orderId="curOrder._id"
        @submit="dialogSettlementSubmit"
      ></dialogSettlement>
    </div>
    <iframe v-if="printUrl" :src="'ChuLinPrint:'+printUrl" width="0" height="0"></iframe>
  </div>
</template>
<script>
import util from "../../../../util/util.js"
import page from "../../../../components/page.vue"
import dialogSettlement from '../../../../components/dialog_settlement.vue'
import resetBtn from "../../../../components/resetBtn.vue"
export default {
  components: { page, dialogSettlement, resetBtn },
  data () {
    return {
      search: {
        "keyword": "",
        "userid": "",   // 用户id
        "starttime": "",
        "endtime": "",
        "state": -1, // 状态 -2 已取消 -1 全部 0 已删除 1 已申请 2 已审核 3 退款中 4 物流中 5退款成功
        "pay_type": -1,  // 支付方式 -1 全部 0 现金 3 线下支付宝 4 线下微信 5 pos机 7 余额 8 赠额 9 积分
        "return_type": -1, // 退换货类型 -1 全部 1 退货 2 换货
        "source": -1, // -1全部 1线上 2线下
      },
      datetimerange: [],
      tableData: [],
      totalMoney: '',
      page: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      // 支付
      curOrder: {},
      dialogSettlementState: false,
      // 打印
      printUrl: '',
    }
  },
  mounted () {
    this.getTableData();
  },
  methods: {
    //取消充值
    handelCancelClick (row) {
      console.log('取消退换货', row)
      this.$confirm('是否取消退换货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.get('/api/ReturnOrder/Return/ReturnOrderRefused', {
          order_return_id: row.no,
        }).then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '取消成功!'
            });
            this.getTableData()
          }
        })
      })
    },
    // 重置筛选
    reset () {
      this.page.page = 1;
      this.search.keyword = '';
      this.search.starttime = '';
      this.search.endtime = '';
      this.datetimerange = [];
      this.search.state = -1;
      this.search.pay_type = -1;
      this.search.return_type = -1;
      this.search.source = -1;
      this.getTableData();
    },
    changeSearch () {
      this.page.page = 1;
      this.getTableData()
    },
    // 改变分页
    changePage (num) {
      this.page.page = num;
      this.getTableData();
    },
    // 获取列表数据
    getTableData () {
      let params = {
        "keyword": this.search.keyword,
        "userid": this.search.userid,
        "starttime": "",
        "endtime": "",
        "state": this.search.state, // 状态 -2 已取消 0 已删除 1 已申请 2 已审核 3 退款中 4 物流中 5退款成功
        "pay_type": this.search.pay_type, // 支付方式 -1 全部 0 现金 3 线下支付宝 4 线下微信 5 pos机 7 余额 8 赠额 9 积分
        "return_type": this.search.return_type, // 退换货类型  1 退货 2 换货
        // "source": this.search.source, // 1线上 2线下
        "pageSize": this.page.pageSize,
        "pageIndex": this.page.page,
      }
      if (this.datetimerange && this.datetimerange.length == 2) {
        params.starttime = ('' + new Date(this.datetimerange[0]).getTime()).substr(0, 10);
        params.endtime = ('' + new Date(this.datetimerange[1]).getTime()).substr(0, 10);
      }
      this.$http.post('/api/ReturnOrder/List', params).then(res => {
        if (res.code == 0) {
          console.log(res)
          this.tableData = res.data.data;
          this.page.total = res.data.count;
          this.getPageTotalMoney()
        }
      })
    },
    // 获取本页合计
    getPageTotalMoney () {
      let totalMoney = 0;
      for (let i = 0; i < this.tableData.length; i++) {
        totalMoney = totalMoney + this.tableData[i].total_price
      }
      this.totalMoney = totalMoney.toFixed(2);
    },
    // 支付
    edit (row) {
      this.curOrder = row
      this.dialogSettlementState = true;
    },
    dialogSettlementSubmit (a) {
      this.dialogSettlementState = false;
      if (a == 'cancel') {
        console.log(a)
      } else if (a == 'fail') {
        this.$message({
          message: '结算失败',
          type: 'error'
        });
      } else if (a == 'success') {
        this.$message({
          message: '结算成功',
          type: 'success'
        });
      }
      this.getTableData();
    },
    // 打印发票
    getInvoice (row) {
      this.$http.get('/api/Order/OrderReceipt', {
        orderNumber: row._id
      }).then(res => {
        if (res.code == 0) {
          let d = res.data;
          util.print(d).then(r => {
            if (r.url != '') {
              this.printUrl = r.url;
              setTimeout(() => {
                this.printUrl = '';
              }, 1000)
            }

          })
        }
      })
    },
  }
}
</script>
<style scoped lang="scss">
.page {
  .searchBox {
    ::v-deep .el-form-item {
      margin-bottom: 0;
      .el-form-item__label {
        padding-right: 5px;
        font-size: 12px;
      }
    }
  }
  .pageConBox {
    padding: 0 0px;
    min-height: 600px;
  }
}
</style>
